var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnhappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1431 33.8573C32.5603 32.3055 31.6054 30.9282 30.366 29.8521C26.4244 26.4701 20.6883 26.4273 16.6989 29.7502C15.4423 30.8073 14.4654 32.1697 13.8574 33.7128",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8571 17.4286V14.1429",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 24C46 36.7025 35.9264 47 23.5 47C11.0736 47 1 36.7025 1 24C1 11.2975 11.0736 1 23.5 1C29.4674 1 35.1903 3.42321 39.4099 7.73654C43.6295 12.0499 46 17.9 46 24Z",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1433 17.4286V14.1429",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhappy);
export default __webpack_public_path__ + "static/media/unhappy.c8039cb93971514ee5fafd9fd5dc2fe9.svg";
export { ForwardRef as ReactComponent };